module.exports = __webpack_public_path__ + "static/media/circle-dollar-yellow.fd7a4abc.png";